export const setProgress = (progress) => ({
    type: "SET_PROGRESS",
    payload: progress,
  });
  
  export const resetProgress = () => ({
    type: "RESET_PROGRESS",
  });
  